var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPayments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.002,
    height: 68.261,
    viewBox: "0 0 83.002 68.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my_payments",
    transform: "translate(0 -11.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8430",
    "data-name": "Path 8430",
    d: "M79.019,21.679l-59.448-10.6a4.87,4.87,0,0,0-5.588,3.945l-3.828,21.96H4.686A4.691,4.691,0,0,0,0,41.67V74.589a4.691,4.691,0,0,0,4.686,4.685H65.321a4.691,4.691,0,0,0,4.686-4.685V63.013c1.737.31,3.414.675,5.02-.285a4.936,4.936,0,0,0,2.311-3.349l5.59-32.073a4.863,4.863,0,0,0-3.909-5.627Zm-62.4-6.2a2.171,2.171,0,0,1,2.48-1.77l59.448,10.6a2.182,2.182,0,0,1,1.74,2.532l-.922,5.3L15.7,20.784Zm50.71,59.11A2.011,2.011,0,0,1,65.321,76.6H4.686a2.011,2.011,0,0,1-2.008-2.008V41.67a2.011,2.011,0,0,1,2.008-2.008H65.321a2.011,2.011,0,0,1,2.008,2.008ZM74.7,58.92c-.416,2.381-3.06,1.665-4.693,1.374V41.67a4.691,4.691,0,0,0-4.686-4.686H12.873l2.364-13.563,3.878.691L78.907,34.778Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8431",
    "data-name": "Path 8431",
    d: "M42.873,99.745H34.99a1.371,1.371,0,0,1,0-2.742h7.883a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(-11.193 -28.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8432",
    "data-name": "Path 8432",
    d: "M21.025,99.745H13.142a1.371,1.371,0,0,1,0-2.742h7.883a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(-3.702 -28.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8433",
    "data-name": "Path 8433",
    d: "M64.721,99.745H56.838a1.371,1.371,0,0,1,0-2.742h7.883a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(-18.467 -28.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8434",
    "data-name": "Path 8434",
    d: "M86.57,99.745H78.687a1.371,1.371,0,0,1,0-2.742H86.57a1.371,1.371,0,1,1,0,2.742Z",
    transform: "translate(-25.742 -28.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8435",
    "data-name": "Path 8435",
    d: "M24.309,85.675h-9.93a3.431,3.431,0,0,1-3.427-3.427V78.31a3.431,3.431,0,0,1,3.427-3.427h9.93a3.431,3.431,0,0,1,3.427,3.427v3.937a3.432,3.432,0,0,1-3.427,3.428Zm-9.93-8.051a.686.686,0,0,0-.685.685v3.937a.686.686,0,0,0,.685.685h9.93a.686.686,0,0,0,.685-.685V78.31a.686.686,0,0,0-.685-.685Z",
    transform: "translate(-3.445 -21.31)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPayments);
export default __webpack_public_path__ + "static/media/my_payments.8ee8eefd164e8631f04ad29fd570cf66.svg";
export { ForwardRef as ReactComponent };